// extracted by mini-css-extract-plugin
module.exports = {"name":"Sidebar_name__3-0XM","btnWrapper":"Sidebar_btnWrapper__1D6GE","wrapper":"Sidebar_wrapper__3v8st","closeIcon":"Sidebar_closeIcon__3-eWY"};